<div class="site-link">
  <link-indicator *ngIf="model.linkIndicator" [name]="model.link?.name" [color]="model.link?.color"></link-indicator>
  <u-icon class="icon" [model]="{ type: 'img', value: model.icon }"></u-icon>
  <div class="root" [class.thin]="!model.subSiteLinks || model.subSiteLinks.length === 0">
    <a (click)="openSiteLink(model, true)" [href]="model.url" target="_blank">
      <span [innerHTML]="model.name"></span>
      <i class="fal external fa-arrow-right"></i>
    </a>

    <ng-container *ngIf="model.subSiteLinks && model.subSiteLinks.length > 0">
      <div class="sep"><i class="fal fa-chevron-double-right"></i></div>
      <a class="sub" *ngFor="let sub of model.subSiteLinks" (click)="openSiteLink(sub, false)" [href]="sub.url" target="_blank">
        <span [innerHTML]="sub.name"></span>
        <i class="fal external fa-arrow-right"></i>
      </a>
    </ng-container>
  </div>
</div>
